<div class="flex-shrink-1 filter-box">
  <form [formGroup]="filterForm">
    <div class="flex grid-gap-10 style2023 flex-wrap">
      <div class="flex grid-gap-10 flex-grow-1 flex-wrap mt-2">
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px" *ngIf="isVME">
          <div class="input-group">
            <div class="input-group-item" style="width: 250px">
              <p-dropdown
                [options]="suppliers"
                class="input-group-filter"
                [formControl]="formControls.supplierId"
                [filter]="true"
                [panelStyleClass]="'styled-dropdown-filter-panel'"
                [placeholder]="'Select Supplier'"
                [showClear]="true"
                (onChange)="onSupplierChanged($event)"
                [resetFilterOnHide]="true"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px">
          <div class="input-group">
            <div class="input-group-item" style="width: 250px">
              <input
                pInputText
                name="searchJobs"
                style="width: 100%"
                type="text"
                placeholder="Job Number/Vehicle Registration"
                [formControl]="formControls.jobNumberOrVehicleReg"
              />
            </div>
          </div>
        </div>
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px">
          <div class="input-group">
            <div class="input-group-item flex align-items-center">
              <i
                class="fa fa-calendar clickable-calendar-icon mr-2"
                (click)="allDatesCalendar.showOverlay()"
              ></i>
              <p-calendar
                #allDatesCalendar
                [formControl]="formControls.dateRange"
                selectionMode="range"
                class="custom-calendar-template"
                dateFormat="dd/mm/yy"
                placeholder="All Dates"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                [maxDate]="maxDate"
              >
                <ng-template pTemplate="date" let-date>
                  <span [class]="customCalendarCellClass(date, formControls.dateRange.value)">{{
                    date.day
                  }}</span>
                </ng-template>
              </p-calendar>
            </div>
            <div
              class="input-group-append"
              *ngIf="formControls.dateRange.value != null"
              (click)="resetDateOfJob()"
            >
              <i class="pi pi-times vertical-align-middle"></i>
            </div>
          </div>
        </div>
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px">
          <div class="input-group">
            <div class="input-group-item">
              <p-dropdown
                [options]="carryOverOptions"
                class="input-group-filter"
                [formControl]="formControls.noCarryOvers"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px">
          <div class="input-group">
            <div class="input-group-item">
              <p-dropdown
                [options]="clashFilterOptions"
                class="input-group-filter"
                [formControl]="formControls.excludeClashSeverities"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="flex-grow-1" style="flex-basis: 100px; max-width: 300px">
          <div class="input-group">
            <div class="input-group-item">
              <p-dropdown
                [options]="numberOfTaskOptions"
                class="input-group-filter"
                [formControl]="formControls.maxNumberOfTasks"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div
          class="flex-grow-1"
          style="flex-basis: 100px; max-width: 200px"
          *ngIf="systemSettings?.routeRecommendationExtenderFilterEnabled"
        >
          <div class="input-group">
            <div class="input-group-item">
              <p-dropdown
                [options]="extenderOptions"
                class="input-group-filter"
                [formControl]="formControls.extender"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div
          class="flex-grow-1"
          style="flex-basis: 100px; max-width: 300px"
          *ngIf="
            systemSettings?.routeRecommendationExtenderFilterEnabled &&
            formControls.extender?.value != PlannedRouteExtenderFilter.OnlyRoutes &&
            !isVME
          "
        >
          <div class="input-group">
            <div class="input-group-item">
              <p-multiSelect
                [options]="extenderFilterJobOptions"
                class="filter-dropdown input-group-filter"
                [formControl]="formControls.extenderSelectedJobs"
              >
                <ng-template let-values pTemplate="selectedItems">
                  {{ values?.length ? joinValues(values) : 'Filter by My Jobs' }}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </div>
        <div class="flex-shrink-1 flex grid-gap-10 flex-wrap">
          <div class="flex-shrink-1 cursor-pointer">
            <button class="button-style" (click)="runSearch(true, true)">
              <i class="fa fa-search"></i>&nbsp;Search
            </button>
          </div>

          <div class="flex-shrink-1">
            <div class="button-style ui-button-tertiary transparent" (click)="resetFilters()">
              <i class="fa fa-undo"></i>
            </div>
          </div>

          <div class="flex-shrink-1" style="min-width: 100px">
            <div class="input-group">
              <div class="input-group-item">
                <p-dropdown
                  [options]="sortByOptions"
                  optionLabel="label"
                  [formControl]="formControls.sortBy"
                >
                  <ng-template let-option pTemplate="selectedItem">
                    Sort By: {{ option.label }}
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="main-body" style="height: 100%">
  <div class="flex flex-wrap">
    <div class="flex-grow-1 scroll-container">
      <div *ngIf="isSupplierPreferencesUpdating" class="warning-container">
        <div class="flex grid-gap-10">
          <div class="flex-shrink-1 warning-icon">
            <i class="fa fa-warning" style="color: #f97316"></i>
          </div>
          <div class="flex-grow-1">
            <div class="warning-title">Your Juno Settings were recently updated</div>
            <div class="warning-text">
              We are in the process of recalculating your routes to reflect your new preferences -
              this may take up to 1 hour. Any routes you've already grabbed won't be affected.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isProcessingNewSupplierRoutes" class="info-container">
        <div class="flex grid-gap-10">
          <div class="flex-shrink-1 info-icon">
            <i class="fa fa-info" style="color: #0082cb"></i>
          </div>
          <div class="flex-grow-1">
            <div>
              You're all set! We've activated your access to the Planned Routes feature and are now
              optimising your routes for maximum efficiency. This may take up to 30 minutes - check
              back soon to see your personalised routes.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showVmePrompt" class="info-container">
        <div class="flex grid-gap-10">
          <div class="flex-shrink-1 info-icon">
            <i class="fa fa-info" style="color: #0082cb"></i>
          </div>
          <div class="flex-grow-1">
            <div>
              Please select a Supplier or enter a Job Number/Vehicle Registration to begin your
              search.
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          !showVmePrompt &&
          !loadingData &&
          routes.length == 0 &&
          !isSupplierPreferencesUpdating &&
          !isProcessingNewSupplierRoutes
        "
      >
        <div class="p-4 text-center">
          <strong>We couldn't find any routes matching your search criteria.</strong>
        </div>
      </div>

      <ng-container *ngIf="!isSupplierPreferencesUpdating && !isProcessingNewSupplierRoutes">
        <div *ngFor="let routeItem of routes">
          <div
            class="scroller"
            [attr.data-routeId]="routeItem.id"
            (click)="onRouteClick(routeItem.id)"
          >
            <planned-route-item
              [routeItem]="routeItem"
              [highlightedRoute]="routeItem.id == highlightedRoute"
              [currentOrgId]="currentOrgId"
              (onHideRouteClicked)="onHideRouteClicked($event, routeItem)"
              (searchByRegClicked)="onSearchByReg($event)"
              [isVME]="isVME"
              [jobNumberOrVehicleRegFilter]="formControls.jobNumberOrVehicleReg.value"
            ></planned-route-item>
            <div (changedVisibility)="onChangedVisibility($event, routeItem.id)"></div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="loadingData">
        <div class="p-4 text-center" style="font-size: 30px">
          Loading.. <i class="fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<route-hide-reason-dialog
  [(visible)]="showHideReasonDialog"
  (onConfirmHide)="onConfirmHide($event)"
>
</route-hide-reason-dialog>
